import { ProjectsEmptyPic } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import type { PropsWithChildren } from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props extends PropsWithChildren {
  title?: string
  // The Templates section sits above the Octopus gallery, so its empty state
  // is shorter than the dashboard's.
  compact?: boolean
}

// Children go under the title: the Templates section puts its upgrade button
// there.
export const ProjectsNotFound: React.FC<Props> = ({
  title = 'No projects yet',
  compact = false,
  children,
}) => (
  <div className={clsJoin(css.not_found_container, compact && css.compact)}>
    <ProjectsEmptyPic className={css.icon} />
    <div className={css.title}>{title}</div>
    {children && <div className={css.action}>{children}</div>}
  </div>
)
